__webpack_require__.p = "/offer-bulk-actions/referrals-hub/";